import SectionHeading from '@/pages/home/components/SectionHeading';
import { latestLicks } from '@/mocks/home';

export default function LatestLicks() {
  return (
    <section id="latest" className="w-full px-5 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-[1320px]">
        <SectionHeading
          index="02"
          eyebrow="最新爆料"
          title="按时间往下读，节奏会慢一点"
          description="不追求一次说清，只把今天发生的动作按顺序留下痕迹。"
        />

        <div className="relative mt-12 md:mt-16">
          <span
            className="absolute bottom-3 left-[6px] top-3 w-px bg-background-300/70 md:left-[6px]"
            aria-hidden="true"
          />
          <ol className="flex flex-col gap-8 md:gap-11">
            {latestLicks.map((item) => (
              <li key={item.id} className="flex items-start gap-5 md:gap-8">
                <span
                  className={`relative z-10 mt-1.5 h-3.5 w-3.5 shrink-0 rounded-full border-2 ${
                    item.hot
                      ? 'border-primary-500 bg-primary-500'
                      : 'border-background-400 bg-background-50'
                  }`}
                  aria-hidden="true"
                />
                <time className="hidden w-28 shrink-0 pt-0.5 font-label text-sm tracking-wide text-foreground-500 md:block">
                  {item.time}
                </time>

                <div className="min-w-0 flex-1 md:flex md:items-baseline md:justify-between md:gap-10">
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-3">
                      <span
                        className={`rounded-full px-2.5 py-0.5 font-label text-[11px] tracking-editorial ${
                          item.hot
                            ? 'bg-primary-100 text-primary-700'
                            : 'bg-secondary-100 text-secondary-700'
                        }`}
                      >
                        {item.tag}
                      </span>
                      <span className="font-label text-xs text-foreground-400 md:hidden">
                        {item.time}
                      </span>
                    </div>
                    <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950 md:text-xl">
                      {item.title}
                    </h3>
                  </div>
                  <span className="mt-3 block shrink-0 font-label text-xs text-foreground-500 md:mt-0 md:text-right">
                    来源 · {item.source}
                  </span>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}